import React, { createContext, useContext, useState } from "react";

const AdminModalContext = createContext();

export const useAdminModal = () => {
  const context = useContext(AdminModalContext);
  if (!context) {
    throw new Error("useAdminModal must be used within AdminModalProvider");
  }
  return context;
};

export const AdminModalProvider = ({ children }) => {
  const [orderDetailsModal, setOrderDetailsModal] = useState({
    isOpen: false,
    order: null,
  });

  const [certificateReviewModal, setCertificateReviewModal] = useState({
    isOpen: false,
    application: null,
    onApplicationUpdated: null,
  });

  const [userDetailsModal, setUserDetailsModal] = useState({
    isOpen: false,
    user: null,
  });

  const [createPromoCodeModal, setCreatePromoCodeModal] = useState({
    isOpen: false,
    onCreated: null,
  });

  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    title: "",
    message: "",
    onConfirm: () => {},
    confirmText: "Potvrdi",
    cancelText: "Otkaži",
  });

  const openOrderDetailsModal = (order) => {
    setOrderDetailsModal({
      isOpen: true,
      order,
    });
  };

  const closeOrderDetailsModal = () => {
    setOrderDetailsModal({
      isOpen: false,
      order: null,
    });
  };

  const openCertificateReviewModal = (application, onApplicationUpdated = null) => {
    setCertificateReviewModal({
      isOpen: true,
      application,
      onApplicationUpdated,
    });
  };

  const closeCertificateReviewModal = () => {
    setCertificateReviewModal({
      isOpen: false,
      application: null,
      onApplicationUpdated: null,
    });
  };

  const openUserDetailsModal = (user) => {
    setUserDetailsModal({
      isOpen: true,
      user,
    });
  };

  const closeUserDetailsModal = () => {
    setUserDetailsModal({
      isOpen: false,
      user: null,
    });
  };

  const openCreatePromoCodeModal = (onCreated = null) => {
    setCreatePromoCodeModal({
      isOpen: true,
      onCreated,
    });
  };

  const closeCreatePromoCodeModal = () => {
    setCreatePromoCodeModal({
      isOpen: false,
      onCreated: null,
    });
  };

  const showConfirmModal = (title, message, onConfirm, confirmText = "Potvrdi", cancelText = "Otkaži") => {
    setConfirmModal({
      isOpen: true,
      title,
      message,
      onConfirm,
      confirmText,
      cancelText,
    });
  };

  const closeConfirmModal = () => {
    setConfirmModal({
      isOpen: false,
      title: "",
      message: "",
      onConfirm: () => {},
      confirmText: "Potvrdi",
      cancelText: "Otkaži",
    });
  };

  const value = {
    orderDetailsModal,
    openOrderDetailsModal,
    closeOrderDetailsModal,
    certificateReviewModal,
    openCertificateReviewModal,
    closeCertificateReviewModal,
    userDetailsModal,
    openUserDetailsModal,
    closeUserDetailsModal,
    createPromoCodeModal,
    openCreatePromoCodeModal,
    closeCreatePromoCodeModal,
    confirmModal,
    showConfirmModal,
    closeConfirmModal,
  };

  return (
    <AdminModalContext.Provider value={value}>
      {children}
    </AdminModalContext.Provider>
  );
};